import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconDiaMadre(props) {
    return (
        <svg
            width={245}
            height={244}
            viewBox="0 0 245 244"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            d="M122.27 243.452C55.038 243.452.352 188.845.352 121.731.352 54.607 55.048 0 122.27 0c67.223 0 121.918 54.607 121.918 121.731 0 67.114-54.695 121.721-121.918 121.721zm0-236.635C58.807 6.817 7.16 58.37 7.16 121.741c0 63.361 51.637 114.914 115.11 114.914 63.464 0 115.1-51.553 115.1-114.914 0-63.37-51.636-114.924-115.1-114.924z"
            fill="#000"
            />
            <path
            d="M182.455 36.691c0-10.7 8.707-19.364 19.414-19.364 10.718 0 19.395 8.664 19.395 19.364 0 10.68-8.677 19.364-19.395 19.364-10.707.01-19.414-8.674-19.414-19.364z"
            fill="#000"
            />
            <path
            d="M191.412 36.691c0-5.77 4.669-10.42 10.457-10.42 5.789 0 10.448 4.65 10.448 10.42 0 5.75-4.649 10.42-10.448 10.42-5.788 0-10.457-4.67-10.457-10.42z"
            fill="#FFDD00"
            />
            <path
            d="M164.4 65.4H142V54.9c0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9v10.5H104V54.9c0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9v10.5H79c-9.4 0-17 7.6-17 17v85.4c0 9.4 7.6 17 17 17h85.4c9.4 0 16.9-7.6 16.9-17V82.4c.1-9.4-7.5-17-16.9-17zM67.8 167.8V97.9h107.8v69.9c0 6.2-5 11.2-11.2 11.2H79c-6.2 0-11.2-5-11.2-11.2zM79 71.1h19.3v2.4c-4 1.6-5.9 6.1-4.4 10.1 1.6 4 6.1 5.9 10.1 4.4 4-1.6 5.9-6.1 4.4-10.1-.8-2-2.4-3.6-4.4-4.4v-2.4h32.2V74c-3.7 2.1-5.1 6.8-3 10.6 2.1 3.7 6.8 5.1 10.6 3 3.7-2.1 5.1-6.8 3-10.6-1-1.8-2.8-3.2-4.8-3.7v-2.2h22.5c6.2 0 11.2 5 11.2 11.2v9.8H67.8v-9.8c0-6.1 5-11.2 11.2-11.2zm63 9.6c0 .3-.1.6-.2.8.1-.2.1-.5.2-.8z"
            fill="#000"
            stroke="#000"
            strokeWidth={1.994}
            strokeMiterlimit={10}
            />
            <path
            d="M142.2 122.2l-10.7-1.6-4.8-9.6c-1.7-3.4-5.9-4.8-9.3-3.1-1.3.7-2.4 1.7-3.1 3.1l-4.8 9.8-10.7 1.6c-3.8.5-6.4 4.1-5.8 7.8.2 1.5.9 2.9 2 3.9l7.8 7.5-1.8 10.7c-.3 2 .2 4 1.5 5.6 2.1 2.5 5.6 3.2 8.5 1.7l9.6-5.1 9.6 5.1c1 .5 2.1.8 3.2.8 2 0 4-.9 5.3-2.5 1.3-1.5 1.9-3.6 1.5-5.6l-1.8-10.7 7.7-7.5c2.8-2.6 2.9-7 .3-9.8-1.2-1.1-2.6-1.9-4.2-2.1zm-.2 7.6l-9.5 9.3c-.3.3-.4.6-.3 1l2.3 13.1v.6c-.1.1-.1.2-.2.3h-1l-12.1-5.8c-.3-.2-.7-.2-1 0l-11.7 6.2h-.9c-.1-.1-.2-.2-.2-.3-.1-.2-.1-.4 0-.6l2.2-13.1c.1-.4-.1-.7-.3-1l-9.5-9.3c-.2-.1-.3-.3-.3-.5-.1-.6.3-1.2.9-1.4l1.7-.2 11.5-1.7c.2 0 .3-.1.5-.2s.3-.2.3-.4l5.8-11.9c.2-.4.6-.6 1-.6.2 0 .4 0 .5.1.2.1.3.3.4.4l5.8 11.9c.1.2.2.3.3.4.1.1.3.2.5.2l13.1 1.9c.6.1 1 .6.9 1.2v.1c-.1.1-.3.2-.5.3h-.2z"
            fill="#000"
            stroke="#000"
            strokeWidth={1.994}
            strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgIconDiaMadre;